import { call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import UpdateLoanExpense from "Communication/ApiClasses/UpdateLoanExpenseRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleUpdateLoanExpense(action) {
  yield put(doLoadingStart(STRINGS.EXPENSE.API_KEYS.LOAN_UPDATE_EXPENSE));
  const updateLoanExpense = new UpdateLoanExpense(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.financialId,
    action.data.payLoad
  );
  try {
    const result = yield call(updateLoanExpense.getData);
    yield put({
      type: actionTypes.LOAN_UPDATE_EXPENSE_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_UPDATE_EXPENSE_ERROR,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.EXPENSE.API_KEYS.LOAN_UPDATE_EXPENSE));
  }
}

// watcher
function* updateLoanExpenseWatcherSaga() {
  yield takeEvery(actionTypes.LOAN_UPDATE_EXPENSE, handleUpdateLoanExpense);
}

export default updateLoanExpenseWatcherSaga;
